import { render, staticRenderFns } from "./ActionsMember.vue?vue&type=template&id=53f35d8a&scoped=true"
import script from "./ActionsMember.vue?vue&type=script&lang=js"
export * from "./ActionsMember.vue?vue&type=script&lang=js"
import style0 from "./ActionsMember.vue?vue&type=style&index=0&id=53f35d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@6.26.3_css-loader@6.11.0_webpack_803fd858e391fe10e6ea2ea3dda7e9cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f35d8a",
  null
  
)

export default component.exports